<template>
	<div id="hres80x-heal-checkup" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#healCheckup">
      <h3 class="box-title color-skin">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{labels['HRES80XP5']['10']}}
      </h3>
    </div>
    <div id="healCheckup" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
        	<!-- header -->
          <div class="hisheal-header">{{labels['HRES80XP3']['20']}} {{labels['HRES80XP3']['25']}}</div>
          <!-- header column -->
          <div class="table-overflow">
            <table class="table-1 text-center">
              <tr>
                <td colspan="2" rowspan="3" class="bg-color-skin table-header-heal-checkup-lv1">{{labels['HRES80XP5']['30']}}</td>
                <td colspan="2" v-for="(dataCol, index) in healCheckupHeader" class="bg-color-skin table-header-heal-checkup-lv1" :key="index">
                  {{dataCol.typheal !== '2' ? labels['HRES80XP5']['90'] + ' ' + dataCol.dteheal : labels['HRES80XP5']['70'] + ' ' + dataCol.dteyear}}
                </td>
              </tr>
              <tr>
                <td colspan="2" v-for="(dataCol, index) in healCheckupHeader" class="bg-color-skin table-header-heal-checkup-lv1" :key="index">
                  {{dataCol.desc_codheal}}
                </td>
              </tr>
              <tr>
                <td v-for="(dataCol, index) in healCheckupHeader" class="bg-color-skin table-header-lv2" :key="index">
                  {{index%2 === 0 ? labels['HRES80XP5']['50'] : labels['HRES80XP5']['60']}}
                </td>
                <td v-for="(dataCol, index) in healCheckupHeader" class="bg-color-skin table-header-lv2" :key="index">
                  {{index%2 === 0 ? labels['HRES80XP5']['50'] : labels['HRES80XP5']['60']}}
                </td>
              </tr>
              <tr v-for="(dataRow, index) in healCheckupRows" :key="index">
                <td colspan="2" class="table-rows-heal-checkup">{{dataRow.codchkhl + ' ' + dataRow.desc_codchkhl}}</td>
                <template v-for="(dataCol, index) in healCheckupHeader">
                  <td :key="index">
                    {{
                      healCheckupDetail
                      .filter(df => (df.dteyear === dataCol.dteyear && dataCol.typheal === df.typheal && df.codchkhl === dataRow.codchkhl))
                      .map(dataMap => {return dataMap.descheck})[0]
                    }}
                  </td>
                  <td :key="index + '1'">
                    {{
                      healCheckupDetail
                      .filter(df => (df.dteyear === dataCol.dteyear && dataCol.typheal === df.typheal && df.codchkhl === dataRow.codchkhl))
                      .map(dataMap => {return dataMap.chkresul})[0]
                    }}
                  </td>
                </template>
              </tr>
            </table>
            <div v-if="healCheckupDetail.length === 0" class="text-center hisheal-nodata">
              No data found.
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres80x-heal-checkup',
  props: [
    'labels',
    'healCheckupHeader',
    'healCheckupDetail',
    'healCheckupRows'
  ]
}
</script>



// WEBPACK FOOTER //
// healthCheckup.vue?45d29e16